import React, { useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { fetchUserProfile } = useContext(AuthContext);
  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
      fetchUserProfile().then(() => {
        navigate('/dashboard');
      });
    } else {
      navigate('/login');
    }
  }, [token, navigate, fetchUserProfile]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <p>Completing authentication...</p>
    </div>
  );
};

export default AuthCallback;

